import { render, staticRenderFns } from "./client-unit-products.vue?vue&type=template&id=15d21f24&scoped=true&lang=pug&"
import script from "./client-unit-products.vue?vue&type=script&lang=ts&"
export * from "./client-unit-products.vue?vue&type=script&lang=ts&"
import style0 from "./client-unit-products.vue?vue&type=style&index=0&id=15d21f24&scoped=true&lang=css&"
import style1 from "./client-unit-products.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d21f24",
  null
  
)

export default component.exports